// @flow

export const FLUSH_CACHED_ROUTES: 'listo/routes/FLUSH_CACHED_ROUTES' = 'listo/routes/FLUSH_CACHED_ROUTES';
export const GET_ROUTE: 'listo/routes/GET_ROUTE' = 'listo/routes/GET_ROUTE';
export const GET_ROUTE_SUCCESS: 'listo/routes/GET_ROUTE_SUCCESS' = 'listo/routes/GET_ROUTE_SUCCESS';
export const GET_ROUTE_FAILED: 'listo/routes/GET_ROUTE_FAILED' = 'listo/routes/GET_ROUTE_FAILED';
export const ACTIVATE_ITEM: 'listo/routes/ACTIVATE_ITEM' = 'listo/routes/ACTIVATE_ITEM';
